import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'resources-list',
  templateUrl: './resources-list.component.html',
  styleUrls: ['./resources-list.component.scss'],
  animations: [slide]
})
export class ResourcesListComponent implements OnInit {
  resources:  FirebaseListObservable<any[]>;
  selectedResource: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {

    this.resources = this.dbService.getResources();

  }


  ngOnInit() {
  }


  showResource(key: string) {
    this.router.navigate([`/resources/${key}`]);
  }


  onAddClicked() {
    this.selectedResource = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditClicked(resource, event) {
    event.stopPropagation();
    this.selectedResource = resource;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(resource, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedResource = resource;
    console.log(this.selectedResource);
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteResource(this.selectedResource.$key,
                                  this.selectedResource.fileKey);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/resources/resources-list/resources-list.component.ts